import { Link } from "react-router-dom";
import ReactCountryFlag from "react-country-flag";
import {
  FaFacebook,
  FaLinkedin,
  FaInstagram,
  FaEnvelope,
  FaMapMarkerAlt,
  FaPhone,
  FaArrowRight,
} from "react-icons/fa";
import "../Style/Footer.css";
import ascentLogo from "../assets/ascentlogo.png";

function Footer() {
  return (
    <footer className="footer-premium">
      {/* Cyber Background Layer */}
      <div className="footer-cyber-bg" aria-hidden="true">
        <div className="aurora-ribbons"></div>
        <div className="aurora-beam beam-1"></div>
        <div className="aurora-beam beam-2"></div>
        <div className="footer-matrix-grid"></div>
        <div className="particle-wrap">
          <span className="particle p1"></span>
          <span className="particle p2"></span>
          <span className="particle p3"></span>
          <span className="particle p4"></span>
          <span className="particle p5"></span>
          <span className="particle p6"></span>
          <span className="particle p7"></span>
          <span className="particle p8"></span>
        </div>

        <svg className="footer-noise" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <filter id="noiseFilter">
            <feTurbulence
              type="fractalNoise"
              baseFrequency="0.85"
              numOctaves="2"
              stitchTiles="stitch"
            />
            <feColorMatrix type="saturate" values="0" />
            <feComponentTransfer>
              <feFuncA type="table" tableValues="0 0.07" />
            </feComponentTransfer>
          </filter>
          <rect width="100%" height="100%" filter="url(#noiseFilter)" />
        </svg>
      </div>

      <div className="matrix-container footer-main-layer">
        {/* Brand Showcase & Global Flag Dock */}
        <div className="footer-hero-section">
          <div className="footer-brand-box">
            <div className="logo-brand-wrapper">
              <img src={ascentLogo} alt="Ascent Inspecta Logo" className="footer-logo-large" />
            </div>
            <h3>Ascent Inspecta Maldives</h3>
            <p>
              Global compliance, rigorous auditing, and ISO certification excellence tailored specifically
              for commercial enterprises, resort hospitality, and marine infrastructure in the Maldives.
            </p>

            <div className="newsletter-mini">
              
              
            </div>
          </div>

          <div className="footer-global-dock">
            <div className="footer-global-header">
              <span className="section-tag tag-blue">GLOBAL PRESENCE</span>
              <h4>Operating Centers &amp; Strategic Hubs</h4>
            </div>

            <div className="flag-banner-grid-footer">
              <div className="flag-banner-card head-office-card hover-lift">
                <div className="flag-badge-top">Head Office</div>
                <div className="flag-image-container">
                  <ReactCountryFlag countryCode="MV" svg className="full-flag-element" title="Maldives" />
                </div>
                <div className="flag-info-box">
                  <h5 className="flag-title-primary">Maldives</h5>
                  <span className="flag-desc-muted">Malé Operations Center</span>
                </div>
              </div>

              <div className="flag-banner-card hover-lift">
                <div className="flag-badge-top reg-badge">Regional Hub</div>
                <div className="flag-image-container">
                  <ReactCountryFlag countryCode="IN" svg className="full-flag-element" title="India" />
                </div>
                <div className="flag-info-box">
                  <h5 className="flag-title-primary">India</h5>
                  <span className="flag-desc-muted">Strategic Consulting Hub</span>
                </div>
              </div>

              <div className="flag-banner-card hover-lift">
                <div className="flag-badge-top glob-badge">Global Hub</div>
                <div className="flag-image-container">
                  <ReactCountryFlag countryCode="US" svg className="full-flag-element" title="United States" />
                </div>
                <div className="flag-info-box">
                  <h5 className="flag-title-primary">United States</h5>
                  <span className="flag-desc-muted">North America Compliance</span>
                </div>
              </div>

              <div className="flag-banner-card hover-lift">
                <div className="flag-badge-top cont-badge">Continental</div>
                <div className="flag-image-container">
                  <ReactCountryFlag countryCode="ZA" svg className="full-flag-element" title="Africa" />
                </div>
                <div className="flag-info-box">
                  <h5 className="flag-title-primary">Africa</h5>
                  <span className="flag-desc-muted">Pan-African Operations</span>
                </div>
              </div>

              <div className="flag-banner-card hover-lift">
                <div className="flag-badge-top reg-badge">Support</div>
                <div className="flag-image-container">
                  <ReactCountryFlag countryCode="LK" svg className="full-flag-element" title="Sri Lanka" />
                </div>
                <div className="flag-info-box">
                  <h5 className="flag-title-primary">Sri Lanka</h5>
                  <span className="flag-desc-muted">Audit Validation</span>
                </div>
              </div>

              <div className="flag-banner-card hover-lift">
                <div className="flag-badge-top reg-badge">Support</div>
                <div className="flag-image-container">
                  <ReactCountryFlag countryCode="BH" svg className="full-flag-element" title="Bahrain" />
                </div>
                <div className="flag-info-box">
                  <h5 className="flag-title-primary">Bahrain</h5>
                  <span className="flag-desc-muted">Middle East Compliance</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-divider"></div>

        {/* Clean Nav Links Column Layout */}
        <div className="footer-nav-grid">
          <div className="footer-links-col">
            <h4>Quick Navigation</h4>
            <Link to="/">Home</Link>
            <Link to="/about">About Us</Link>
            <Link to="/certifications">Certifications Matrix</Link>
            <Link to="/blog">Strategic Blog</Link>
            <Link to="/contact">Contact Support</Link>
          </div>

          <div className="footer-links-col contact-col">
            <h4>Connect Headquarters</h4>
            <div className="footer-contact-item">
              <FaMapMarkerAlt /> <span>Minhaa, Karankaa Magu, Malé, Republic of Maldives</span>
            </div>
            <div className="footer-contact-item">
              <FaPhone /> <a href="tel:+919867180395">+91 9867180395</a>
            </div>
            <div className="footer-contact-item">
              <FaEnvelope /> <a href="mailto:info@ascentinspecta.com">info@ascentinspecta.com</a>
            </div>
          </div>

          <div className="footer-links-col social-col">
            <h4>Social Channels</h4>
            <p className="social-intro-desc">Stay updated with the latest ISO standards and auditing updates.</p>
            <div className="footer-social-dock">
              <a
                href="https://in.linkedin.com/in/satyajeet-sharma-20970115?trk=public_post_feed-actor-name"
                target="_blank"
                rel="noreferrer"
                aria-label="LinkedIn"
              >
                <FaLinkedin />
              </a>
              <a
                href="https://www.instagram.com/maldives.ascent/profilecard/?igsh=MWVrMWw4MXhlM2h3N"
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
              >
                <FaInstagram />
              </a>
              <a
                href="https://www.facebook.com/AscentMaldives"
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook"
              >
                <FaFacebook />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright Bar */}
      <div className="footer-copyright-bar">
        <div className="matrix-container copyright-inner">
          <p>© {new Date().getFullYear()} Ascent Inspecta. Excellence in Global Compliance.</p>
          <div className="footer-legal-links">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;